import { Header } from './Header';
import { Hero } from './Hero';
import { DocumentSection } from './DocumentSection';
import Footer from './Footer';
import PropertyDocuments from './features/Documents/propertyDocuments/PropertyDocuments';

const LandingPage = () => {
  // const rentAgreements = [
  //   'Rent Agreement for Shop',
  //   'Rent Agreement for Shed',
  //   'Rent Agreement for Kothi',
  //   'Rent Agreement for Office',
  //   'Rent Agreement for House',
  //   'Rent Agreement for Floor',
  //   'Rent Agreement for Flat',
  //   'Rent Agreement for Factory',
  //   'Rent Agreement for Godown',
  // ];

  // const saleAgreements = [
  //   'Agreement to Sell - Commercial Property',
  //   'Agreement to Sell - Residential Property',
  //   'Sale Deed',
  // ];

  // const businessAgreements = [
  //   'Dealership Agreement',
  //   'Master Agreement',
  //   'Non Disclosure Agreement',
  // ];

  // const vehicleAgreements = [
  //   'Vehicle Sale or Purchase Agreement - Non Commercial without Driver',
  //   'Vehicle Sale or Purchase Agreement - Non Commercial with Driver',
  //   'Vehicle Sale or Purchase Agreement - Commercial without Driver',
  //   'Vehicle Sale or Purchase Agreement - Commercial with Driver',
  // ];

  // const hindiAgreements = [
  //   'व्यावसायिक गोदाम के किराए का अनुबंध पत्र',
  //   'व्यावसायिक शेड के किराए का अनुबंध पत्र',
  //   'व्यावसायिक दुकान के किराए का अनुबंध पत्र',
  //   'व्यावसायिक कार्यालय के किराए का अनुबंध पत्र',
  //   'आवासीय फ्लैट के किराए का अनुबंध पत्र',
  //   'व्यावसायिक संपत्ति का क्रय विक्रय अनुबंध',
  //   'आवासीय संपत्ति का क्रय विक्रय अनुबंध',
  //   'संपत्ति का बिक्री विलेख',
  // ];

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#fff' }}>
      <Header />
      <Hero />
      <PropertyDocuments />      {/* <div id="documents" style={{ maxWidth: 1440, margin: '0 auto', padding: '64px 32px' }}>
        <DocumentSection title="Rent Agreements" documents={rentAgreements} />
        <DocumentSection title="Sale and Property Agreements" documents={saleAgreements} />
        <DocumentSection title="Business and Legal Agreements" documents={businessAgreements} />
        <DocumentSection title="Vehicle Agreements" documents={vehicleAgreements} />
        <DocumentSection title="Hindi Agreements" documents={hindiAgreements} />
      </div> */}

      <Footer />
    </div>
  );
};

export default LandingPage;
